import z from 'zod'

import { ENDPOINT } from '@/config/endpoint'
import { apiFactory, apiOk } from '@/libs/api'
import { zh } from '@/libs/utils/zod'
import { RecordId } from '@/types/common'

import { ItemCategoryDto } from '../dto/item-category-dto'

type ItemCategoryMutation = Pick<ItemCategoryDto, 'name' | 'desc' | 'isActive'>

export const itemCategoryApi = {
  list: apiFactory({
    url: ENDPOINT.inventory.category.list,
    method: 'get',
    schema: {
      result: apiOk(z.object({ categories: ItemCategoryDto.array() })),
    },
  }),
  detail: apiFactory({
    url: ENDPOINT.inventory.category.detail,
    method: 'get',
    schema: {
      params: zh.ParamsId,
      result: apiOk(z.object({ category: ItemCategoryDto })),
    },
  }),
  create: apiFactory({
    url: ENDPOINT.inventory.category.create,
    method: 'post',
    schema: {
      body: z.custom<ItemCategoryMutation>(),
    },
  }),
  update: apiFactory({
    url: ENDPOINT.inventory.category.update,
    method: 'put',
    schema: {
      body: z.custom<RecordId & ItemCategoryMutation>(),
    },
  }),
}
